import * as React from "react";
import { IInputFieldProps, DateFieldSchema } from "@generation/core";
import { InputField, InputFieldProps } from "@shared/common";
import { withHideOnFieldHoc } from "../Hoc/withHideOnFieldHoc";
import { withRegisterFieldHoc } from "../Hoc/withRegisterFieldHoc";
import { withRenderFieldHoc } from "../Hoc/withRenderFieldHoc";
const InputMask = require("react-input-mask");
import { useFormPropsContext } from "../Index";
import { withValueSetHoc } from "../Hoc/withValueSetHoc";
import { onChangeHoc } from "../Hoc/onChangeHoc";
import { translate } from "../Locales/translator";

const RegisteredTextField = withRegisterFieldHoc(
  withRenderFieldHoc((props: IInputFieldProps<DateFieldSchema> & InputFieldProps) => {
    const formProps = useFormPropsContext();

    if (formProps?.fieldDefaults?.date?.inputMask) {
      return (
        <InputMask
          name={props.name}
          disabled={props.disabled}
          aria-labelledby={props.ariaLabelledby}
          aria-describedby={props.ariaDescribedBy}
          mask={props.field.dateMask ?? "99-99-9999"}
          maskChar=""
          value={props.value || ""}
          onChange={props.onChange}
          className="form-control"
          placeholder={props.field.placeholder ?? translate("DateInputPlaceHolder")}
          id={props.name}
          style={{ display: props.displayStyle }}
          maxLength={props.maxLength}
        />
      );
    }

    return (
      <InputField {...props} type="text" id={props.name} placeholder={translate("DateInputPlaceHolder")} />
    );
  })
);

export const DateField = React.memo(
  onChangeHoc(
    withValueSetHoc(
      withHideOnFieldHoc((props: IInputFieldProps<DateFieldSchema>) => (
        <RegisteredTextField {...props} displayStyle="block" />
      ))
    )
  )
);
